import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const PageHeader = ({
  title,
  subtitle,
  onBack,
  backTo,
  showBack = true,
  actions,
  dense = true,
  sx,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) return onBack();
    if (backTo) return navigate(backTo);
    return navigate(-1);
  };

  return (
    <Box
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? alpha(theme.palette.background.paper, 0.92)
            : alpha(theme.palette.background.paper, 0.96),
        borderBottom: "1px solid",
        borderColor: "divider",
        boxShadow: (theme) =>
          theme.palette.mode === "dark"
            ? `0 1px 8px ${alpha(theme.palette.common.black, 0.22)}`
            : "0 1px 2px rgba(15, 23, 42, 0.04)",
        px: { xs: 1.25, md: 2 },
        py: dense ? 1 : 1.25,
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
          {showBack && (
            <IconButton
              size="small"
              onClick={handleBack}
              sx={{
                bgcolor: (theme) => theme.palette.action.hover,
                border: "1px solid",
                borderColor: "divider",
                color: "text.secondary",
                width: 32,
                height: 32,
                flex: "0 0 auto",
                boxShadow: (theme) =>
                  theme.palette.mode === "dark"
                    ? "none"
                    : "0 1px 2px rgba(15, 23, 42, 0.06)",
                "&:hover": {
                  bgcolor: "action.selected",
                  borderColor: "primary.main",
                  color: "primary.main",
                },
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontWeight: 800, fontSize: dense ? "0.95rem" : "1.05rem", color: "text.primary", lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography
                component="div"
                sx={{ fontSize: "0.72rem", color: "text.secondary", lineHeight: 1.2, mt: 0.25 }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {actions && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flex: "0 0 auto" }}>
            {actions}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;
